import React from 'react'
import useAuth from '../../Hooks/useAuth'

const Loader = () => {
    const {loader} = useAuth()
  return (
    <div className={`loader ${loader ? '' : 'vanish-loader'}`}>
        <div className="loader-item">
            <img src={require("../../assets/images/loader/120431-nft-monkey.gif")} alt="" />
        </div>
    </div>
  )
}

export default Loader